var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDashCash = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30.072,
    height: 35.251,
    viewBox: "0 0 30.072 35.251",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234",
    transform: "translate(-665.428 -292.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(1164.915 -72.534)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M74.16,929.393V896.5a1.144,1.144,0,0,1,1.185-1.138h26.737a1.144,1.144,0,0,1,1.15,1.138v32.9l-5.88-2.128L92.2,929.44l-4.41-2.175-4.41,2.175-4.41-2.175-4.416,2.175",
    transform: "translate(-573.147 -529.807)",
    fill: "none",
    stroke: "#006d48",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M744.037,1530.88a2.071,2.071,0,0,0-.515-1.477,4.681,4.681,0,0,0-1.747-1.013,20.646,20.646,0,0,1-2.127-.921,6.784,6.784,0,0,1-1.533-1.053,4.227,4.227,0,0,1-1-1.4,4.694,4.694,0,0,1-.356-1.912,4.243,4.243,0,0,1,1.222-3.133,5.155,5.155,0,0,1,3.247-1.425v-2.421h1.81v2.455a4.722,4.722,0,0,1,3.133,1.668,5.5,5.5,0,0,1,1.131,3.591h-3.269a3.117,3.117,0,0,0-.56-2.03,1.848,1.848,0,0,0-1.5-.674,1.908,1.908,0,0,0-1.436.526,2.006,2.006,0,0,0-.509,1.454,1.913,1.913,0,0,0,.5,1.38,5.486,5.486,0,0,0,1.85,1.063,20.467,20.467,0,0,1,2.223,1.024,6.412,6.412,0,0,1,1.471,1.086,4.2,4.2,0,0,1,.916,1.38,4.751,4.751,0,0,1,.317,1.8,4.222,4.222,0,0,1-1.2,3.122,5.256,5.256,0,0,1-3.3,1.414v2.251h-1.8v-2.24a5.443,5.443,0,0,1-3.592-1.645,5.309,5.309,0,0,1-1.272-3.717h3.269a3.009,3.009,0,0,0,.639,2.065,2.332,2.332,0,0,0,1.838.718,2.244,2.244,0,0,0,1.572-.526A1.825,1.825,0,0,0,744.037,1530.88Z",
    transform: "translate(-1226.713 -1145.475)",
    fill: "#006d48"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDashCash, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/dash_cash.6074454d.svg";
export { ForwardRef as ReactComponent };